import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./Layout/ProtectedRoute";
import Unauthorized from "./pages/Unauthorized";
import "./App.css";
import CompaniesDetail from "./pages/CompaniesDetail";





const Admission = lazy(() => import("./pages/admission"));
const VisitedEnquiry = lazy(() => import("./pages/visitedEnqiries"));
const Login = lazy(() => import("./pages/Login"));
const Enquiry = lazy(() => import("./pages/Enquiry"));
const Blogs = lazy(() => import("./pages/Blogs"));
const SalarySlip = lazy(() => import("./pages/SalarySlip"));
const StudentAdmission = lazy(() => import("./pages/StudentAdmission"));
const DropStudentAdmission = lazy(() => import("./pages/dropStudents"));
const StudentProfile = lazy(() => import("./pages/StudentProfile"));
const ProjectEnquiry = lazy(() => import("./pages/ProjectEnquiry"));
const FeeDetails = lazy(() => import("./pages/FeeDetails"));
// const OnlineAdmission = lazy(() => import("./pages/OnlineAdmissions"));
const AddUser = lazy(() => import("./pages/AddUser"));
// const GenerateCertificate = lazy(() => import("./pages/GenerateCertificate"));
const Webinar = lazy(() => import("./pages/Webinar"));
const HackathonRegistration = lazy(() => import("./pages/HackathonRegistration"));
const Resume = lazy(() => import("./pages/resume"));
const Job = lazy(() => import("./pages/Job"));
const Preloader = lazy(() => import("./components/preloader"));
const Batch = lazy(() => import("./pages/Batch"));
const BatchDetails = lazy(() => import("./pages/batchdetails"));
const Portfolio = lazy(()=>import("./pages/Portfolio"))
const SummerCourse = lazy(() => import("./pages/SummerCourse"));
const OnlineVisiting = lazy(() => import("./pages/OnlineVisiting"));
const CertificateScanner = lazy(() => import("./pages/CertificateScanner"));
const Jmd = lazy(()=>import("./pages/Jmd"))
const DocsManagement = lazy(()=>import("./pages/Docs"))
const EnquiryInterviewSection = lazy(()=>import("./pages/EnquiryInterview"))
const EnquiryMindVerse = lazy(()=>import("./pages/EnquiryMindVerse"))
function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Preloader />}>
        <AuthProvider>
          <Routes>
            {/* ✅ Public Route */}
            <Route path="/login" element={<Login />} />

            {/* ✅ ALL ROLES ACCESS */}
            <Route
              path="/"
              element={
                <ProtectedRoute allowedRoles={["admin", "subuser", "user", "superadmin"]} />
              }
            >
              <Route index element={<Admission />} />

              <Route path="/visited-enquiries" element={<VisitedEnquiry />} />
              <Route path="/online-visiting" element={<OnlineVisiting />} />

              {/* ✅ Students List */}
              <Route path="/students" element={<StudentAdmission />} />

              {/* ✅ Student Details (NOW FOR ALL ROLES) */}
              <Route path="/students/:id" element={<StudentProfile />} />

              <Route path="/enquiry" element={<Enquiry />} />
              <Route path="/enquiry-mindverse" element={<EnquiryMindVerse/>}/>
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/job" element={<Job />} />
              <Route path= "/portfolio" element={<Portfolio/>}/>
              <Route path="/project" element={<ProjectEnquiry />} />
              <Route path="/summer-course" element={<SummerCourse />} />
              {/* <Route path="/salary-slip" element={<SalarySlip />} /> */}
              <Route path="/certificate-scanner" element={<CertificateScanner />} />
              <Route path="/companies-details" element={<CompaniesDetail/>}/>
            
            <Route path= "/jmd" element={<Jmd/>}/>
            <Route path="/docs" element={<DocsManagement/>}/>
            </Route>
            <Route path="/enquiry-form" element={<EnquiryInterviewSection/>}/>
            {/* ✅ ADMIN + SUPERADMIN ONLY */}
            <Route
              path="/"
              element={<ProtectedRoute allowedRoles={["admin", "superadmin"]} />}
            >
              <Route path="/drop-students" element={<DropStudentAdmission />} />
              <Route path="/fee-details" element={<FeeDetails />} />
              {/* <Route path="/online-admission" element={<OnlineAdmission />} /> */}
              <Route path="/salary-slip" element={<SalarySlip />} />
              <Route path="/add-user" element={<AddUser />} />
              {/* <Route path="/certificate" element={<GenerateCertificate />} /> */}
              <Route path="/webinar" element={<Webinar />} />
              <Route path="/hackathon" element={<HackathonRegistration />} />

              {/* ✅ Batch Routes */}
              <Route path="/batch" element={<Outlet />}>
                <Route index element={<Batch />} />
                <Route path=":batchId" element={<BatchDetails />} />
              </Route>
            </Route>

            {/* ❌ Unauthorized */}
            <Route path="/unauthorized" element={<Unauthorized />} />
          </Routes>
        </AuthProvider>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
